import i18n from '@/libs/i18n/i18n'

export default () => ({
    statuses: [
        {value: 'active', text: i18n.t('general.active')},
        {value: 'inactive', text: i18n.t('general.inactive')}
    ],
    paymentTypes: [
        {value: 'pos', text: i18n.t('general.pos')},
        {value: 'bankCard', text: i18n.t('general.bankCard')},
        {value: 'cash', text: i18n.t('general.cash')},
        {value: 'donationClinicAccount', text: i18n.t('general.donationClinicAccount')},
        {value: 'ipdAccount', text: i18n.t('general.ipdAccount')}
    ],
    paymentTypesForReturn: [
        {value: 'bankOfCompany', text: i18n.t('general.bankOfCompany')},
        {value: 'cashImprestFunds', text: i18n.t('general.cashImprestFunds')}

    ],
    excessPaymentTypes: [
        {value: 'pos', text: i18n.t('general.pos')},
        {value: 'bankCard', text: i18n.t('general.bankCard')},
    ],
    yesNoStatus: [
        {value: 'yes', text: i18n.t('general.yes')},
        {value: 'no', text: i18n.t('general.no')}
    ],
    yesNoStatusEn: [
        {value: 'yes', text: 'Yes'},
        {value: 'no', text: 'No'}
    ],

    presentAbsentStatus: [
        {value: 'present', text: 'Present'},
        {value: 'absent', text: 'Absent'}
    ],

    cycles: [
        {value: 'irregular', text: i18n.t('generalInformation.irregular')},
        {value: 'regular', text: i18n.t('generalInformation.regular')},
        {value: 'menopause', text: i18n.t('generalInformation.menopause')},
    ],

    radiologyTypes: [
        {value: 'mri', text: i18n.t('pastHistory.mri')},
        {value: 'ct_scan', text: i18n.t('pastHistory.ctScan')},
        {value: 'mammography', text: i18n.t('pastHistory.mammography')},
        {value: 'hsg', text: 'HSG'},
    ],

    gravidityTypes: [
        {value: 'ep', text: i18n.t('pastObstetricHistory.ectopicPregnancy')},
        {value: 'ip', text: i18n.t('pastObstetricHistory.intrauterinePregnancy')},
    ],

    ipTypes: [
        {value: 'parity', text: i18n.t('pastObstetricHistory.parity')},
        {value: 'abortion', text: i18n.t('pastObstetricHistory.abortion')},
        {value: 'molar', text: i18n.t('pastObstetricHistory.molar')},
    ],

    posNegStatus: [
        {value: 'positive', text: i18n.t('general.positive')},
        {value: 'negative', text: i18n.t('general.negative')}
    ],


    physicalExamTypes: [
        {value: 'breast_exam', text: i18n.t('physicalExam.breastExam')},
        {value: 've', text: i18n.t('physicalExam.ve')}
    ],
});
